const s = ["up", "down"], n = ["mentions", "messages"], t = {
  UNREAD_PILL_DIRECTIONS: s,
  UNREAD_PILL_KINDS: n
};
export {
  s as UNREAD_PILL_DIRECTIONS,
  n as UNREAD_PILL_KINDS,
  t as default
};
//# sourceMappingURL=unread-pill-constants.js.map
